import React from 'react';
import { useEffect } from 'react';
import { FormGroup, Label, Input, Form, Row, Col } from 'reactstrap';
import MaterialTable, { MTableToolbar } from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { unregister } from "../Interceptor.js";
import { Alert } from 'reactstrap';
import AlertTitle from "@material-ui/lab/AlertTitle";

const tableIcons = {
    Add: React.forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: React.forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: React.forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: React.forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: React.forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: React.forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: React.forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: React.forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: React.forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: React.forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: React.forwardRef((props, ref) => <Clear {...props} ref={ref} />),  
    Search: React.forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: React.forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: React.forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: React.forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

var dataNovedades = [{}];
var dataTipoNovedades = [{}];
var dataOptionsNovedades = [{}];

var dataEjemploI = [{}];

export default function General() {

    useEffect(() => {
        getNovedadesEmpleados();
        setidCliente(localStorage.getItem("idEmpleado"));
        gettiposNovedad();
        getListaProductosServicios();
        getEjemplo();
    }, []);

    const [dataNovedad, setNovedades] = React.useState(dataNovedades);
    const [dataTipoNovedad, setTipoNovedades] = React.useState(dataTipoNovedades);
    const [idCliente, setidCliente] = React.useState(0);

    const [listaproductos, setListaProductos] = React.useState({});

    const getNovedadesEmpleados = () => {

        var myHeaders = new Headers();
        var id = localStorage.getItem("idEmpleado");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var mes = localStorage.getItem("mes");
        var anio = localStorage.getItem("anio");

        var url = "./api/Novedad/TraerNovedadxEmpleado?iIdEmpleado=" + id + "&shMes=" + mes + "&iAno=" + anio;
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                setNovedades(result.basePresentationList);
            })
            .catch(error => console.log('error', error));
    }
    const [dataEjemplo, setdataEjemplo] = React.useState(dataEjemploI);
    const getEjemplo = () => {

        var myHeaders = new Headers();
        var id = localStorage.getItem("idEmpleado");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var mes = localStorage.getItem("mes");
        var anio = localStorage.getItem("anio");

        var url = "./api/User/ejemplo";
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                setdataEjemplo(result);
            })
            .catch(error => console.log('error', error));
    }

    const createNovedad = (novedad) => {
        var myHeaders = new Headers();

        var indice = Number(novedad.ProductoNombre);
        
        //var addNoved = dataOptionsNovedades[indice];
        console.log(novedad);
        //var  CodNovedad  = addNoved.Codigo;
        
       // addNoved =   dataOptionsNovedades[parseInt(novedad.ProductoNombre)].c;


        var NewNovraw = JSON.stringify({
            "Id_empleado": idCliente,
            "Id_producto": novedad.Id_producto,
            "TipoNovedad": 1,
            "EstadoNovedad": 1,
            "FechaRegistro": new Date(),
            "Cantidad": novedad.Cantidad,
            "ValorUnitario": novedad.ValorUnitario,
            "PorcentajeImpto": novedad.con_por_impuesto2,
            "TipoIncapacidad": novedad.TipoIncapacidad,
            "OtroConcepto": novedad.OtroConcepto,
            "FechaInicio": novedad.FechaInicio,
            "FechaFin": novedad.FechaFin,
            "PorcentajeIva": 0,
            "Iva": 0
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: NewNovraw,
            redirect: 'follow'
        };

        fetch("./api/Novedad/CrearNovedad", requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                getNovedadesEmpleados(idCliente);
            })
            .catch(error => console.log('error', error));
    }
    const deleteNovedad = (novedad) => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            redirect: 'follow'
        };
        var url = "./api/Novedad/EliminarNovedad?iIdNovedad=" + novedad;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                
                
                getNovedadesEmpleados(idCliente);
            })
            .catch(error => console.log('error', error));
    }
    const novedadesOptions = {};
    const gettiposNovedad = () => {
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var apiurl = "./api/Auxiliar/ListaTipoNovedad";

        fetch(apiurl, requestOptions)
            .then(response => response.json())
            .then(result => {
                
                dataOptionsNovedades = result.basePresentationList;

                setTipoNovedades(dataNovedades);

                dataOptionsNovedades.map((novedad, index) => {
                    const { Codigo, Descripcion } = novedad;
                    novedadesOptions[index] = Descripcion;
                });
                console.log(novedadesOptions);
                
                setTipoNovedades(novedadesOptions);
            })
            .catch(error => console.log('error', error));
    }
    var productoID = 0;

    const getproductId = (id, novedad) => {
      
        console.log(novedad);
        
        update(novedad);
    }

    const getListaProductosServicios = () => {
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };


        fetch("./api/Novedad/TraerProductosServiciosEmpresa", requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                setListaProductos(result.basePresentation);
            })
            .catch(error => console.log('error', error));
    }

    const update = (novedad) => {

        
        var myHeaders = new Headers();

        var raw = JSON.stringify({
            "Id_novedad": novedad.Id_novedad,
            "Id_empleado": idCliente,
            "EstadoNovedad": 1,
            "Id_producto": novedad.Id_producto,
            "TipoNovedad": novedad.TipoNovedad,
            "Cantidad": novedad.Cantidad,
            "ValorUnitario": novedad.ValorUnitario,
            "PorcentajeImpto": novedad.con_por_impuesto2,
            "TipoIncapacidad": novedad.TipoIncapacidad,
            "OtroConcepto": novedad.OtroConcepto,
            "FechaInicio": novedad.FechaInicio,
            "FechaFin": novedad.FechaFin,
            "FechaRegistro": new Date(),
        });

        

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("./api/Novedad/ModificarNovedad", requestOptions)
            .then(response => response.json())
            .then(result => {
                
                getNovedadesEmpleados(idCliente);
            })
            .catch(error => console.log('error', error));
    }

    const [columns, setColumns] = React.useState([
        {
            title: 'Name', field: 'name',
            editComponent: props => (
                <input
                    type="text"
                    value={props.value}
                    onChange={e => props.onChange(e.target.value)}
                />
            )
        },
        { title: 'Surname', field: 'surname' },
        { title: 'Birth Year', field: 'birthYear', type: 'numeric' },
        {
            title: 'Birth Place',
            field: 'birthCity',
            lookup: { 34: 'İstanbul', 63: 'Şanlıurfa' },
        }, {
            title: 'Tipo Novedad',
            field: 'tiponovedad',
            lookup: {
                268774: 'AFC',
                268782: 'Anticipo',
                268784: 'Anticipo',
                268759: 'ApoyoSost',
                268745: 'AuxilioNS',
                268744: 'AuxilioS',
                268721: 'AuxilioTransporte',
                268720: 'Basico',
                268743: 'BonificacionNS',
                268742: 'BonificacionS',
                268761: 'BonifRetiro',
                268735: 'Cesantias',
                268736: 'CesantíasIntereses',
                268756: 'Comision',
                268751: 'CompensacionE',
                268750: 'CompensacionO',
                268747: 'Concepto Felicitación',
                268749: 'ConceptoNS',
                268748: 'ConceptoS',
                268775: 'Cooperativa',
                268767: 'Deducciones-Sindicatos',
                268765: 'DeduccionSP',
                268766: 'DeduccionSub',
                268140: 'Desarrollo de software a la medida.',
                268780: 'Deuda',
                268757: 'Dotacion',
                268778: 'Educacion',
                268758: 'Eliminar Nomina',
                268776: 'EmbargoFiscal',
                268764: 'FondoPension',
                268724: 'HED',
                268727: 'HEDDF',
                268725: 'HEN',
                268729: 'HENDF',
                268728: 'HRDDF',
                268726: 'HRN',
                268730: 'HRNDF',
                268746: 'HuelgaLegal',
                268738: 'Incapacidad',
                268762: 'Indemnizacion',
                268772: 'Libranza',
                268771: 'Libranza-Crédito',
                268739: 'LicenciaMP',
                268741: 'LicenciaNR',
                268740: 'LicenciaR',
                268785: 'OtraDeduccion',
                268755: 'PagoAlimentacionNS',
                268754: 'PagoAlimentacionS',
                268737: 'PagoIntereses',
                268753: 'PagoNS',
                268752: 'PagoS',
                268781: 'PagoTercero',
                268783: 'PagoTercero',
                268786: 'PensionVoluntaria',
                268777: 'PlanComplementarios',
                268733: 'Primas',
                268734: 'PrimasNS',
                268779: 'Reintegro',
                268787: 'Reintegro',
                268773: 'RetencionFuente',
                268719: 'SalarioIntegral',
                268763: 'Salud',
                268770: 'SancionPriv',
                268769: 'SancionPublic',
                268768: 'Sindicatos',
                268760: 'Teletrabajo',
                268732: 'VacacionesCompensadas',
                268731: 'VacacionesComunes',
                268723: 'ViaticoManuAlojNS',
                268722: 'ViaticoManuAlojS'
            }
        }
    ]);

    const [data, setData] = React.useState([
        { name: 'Mehmet', surname: 'Baran', birthYear: 1987, birthCity: 63, tiponovedad:0 },
        { name: 'Zerya Betül', surname: 'Baran', birthYear: 2017, birthCity: 34, tiponovedad:1 },
    ]);


    const updateNovedad = (novedad) => {
        
        console.log(novedad);
        var id = novedad.Id_producto;
        getproductId(id, novedad);
    }
    return (
        <React.Fragment>
            <h5 style={{ textAlign: "center", fontSize: "20px" }}>Comprobante de Nómina</h5>
            <Form>
                <Row>
                    
                    <Col md="12">
                        <Alert variant="filled" severity="warning" isOpen={true}>
                            <AlertTitle>Asignación de Cantidades</AlertTitle>
                            Para novedades que sean medidas por horas o dias es posible especficar la cantidad en el campo de CANTIDAD, si es un valor mensual asignar el valor 1.
                        </Alert>
                        <MaterialTable
                            columns={[
                                {
                                    title: "ID",
                                    field: "Id_novedad",
                                    type: "string",
                                    filtering: true
                                },
                                {
                                    title: 'Tipo de Novedad', field: 'TipoNovedad', initialEditValue: 0, lookup: { 1: "Periódico", 2: "No Periódico" },
                                    render: (rowData) => {
                                        return (
                                            rowData.TipoNovedad == 1 ? <p style={{ color: "#E87722", fontWeight: "bold" }}>Periódico</p> :
                                                rowData.TipoNovedad == 2 ? <p style={{ color: "#008240", fontWeight: "bold" }}>No Periódico</p> :
                                                    <p style={{ color: "#B0B700", fontWeight: "bold" }}>No Periodico</p>
                                        );
                                    }
                                },
                                {
                                    title: 'Novedad', field: 'Id_producto', initialEditValue: 0, lookup: listaproductos

,
                                    render: (rowData) => {
                                        return (
                                            <p style={{ color: "#E87722", fontWeight: "bold" }}>{rowData.ProductoNombre}</p>
                                        );
                                    }
                                    
                                },
                                {
                                    title: "Cantidad (m/d/h)",
                                    field: "Cantidad",
                                    type: "numeric",
                                    filtering: true
                                },
                                {
                                    title: "Valor Unitario",
                                    field: "ValorUnitario",
                                    type: "currency",
                                    filtering: true
                                }
                                ,
                                {
                                    title: "Porcentaje Impuesto",
                                    field: "con_por_impuesto2",
                                    type: "numeric",
                                    filtering: true
                                }
                                ,
                                {
                                    title: "Fecha hora inicio",
                                    field: "FechaInicio",
                                    type: "datetime",
                                    filtering: true
                                },
                                {
                                    title: "Fecha hora fin",
                                    field: "FechaFin",
                                    type: "datetime",
                                    filtering: true
                                },
                                {
                                    title: "texto Libranza",
                                    field: "TipoIncapacidad",
                                    type: "string",
                                    filtering: true
                                },
                                {
                                    title: "Otro concepto",
                                    field: "OtroConcepto",
                                    type: "string",
                                    filtering: true
                                }
                            ]}

                            data={dataNovedad}
                            title="Novedades"
                            onSelectionChange={(newSelection) => {

                            }}
                            icons={tableIcons}
                            
                            options={{
                                filtering: true,
                                exportButton: true,
                                exportAllData: true,
                                maxBodyHeight: '800px',
                                search: false,

                            }}
                            style={{ fontFamily: 'Hammersmith One' }}
                            editable={{
                                onRowAdd: (newData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            
                                            createNovedad(newData);
                                            /*setState((prevState) => {
                                                const data = [...prevState.data];
                                                
                                                data.push(newData);
                                                return { ...prevState, data };
                                            });*/
                                        }, 600);
                                    }),
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            if (oldData) {
                                                console.log(oldData);
                                                updateNovedad(newData);
                                            }
                                        }, 3000);
                                        
                                    }),
                                onRowDelete: (oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            
                                            deleteNovedad(oldData.Id_novedad);
                                            /*setState((prevState) => {
                                                const data = [...prevState.data];
                                                data.splice(data.indexOf(oldData), 1);
                                                return { ...prevState, data };
                                            });*/
                                        }, 600);
                                    }),
                            }}
                        />


                        {/*<MaterialTable
                            title="Custom Edit Component Preview"
                            columns={columns}
                            data={dataEjemplo}
                            editable={{
                                onRowAdd: newData =>
                                    new Promise((resolve, reject) => {
                                        setTimeout(() => {
                                            setData([...data, newData]);

                                            resolve();
                                        }, 1000)
                                    }),
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve, reject) => {
                                        setTimeout(() => {
                                            const dataUpdate = [...data];
                                            const index = oldData.tableData.id;
                                            dataUpdate[index] = newData;
                                            setData([...dataUpdate]);

                                            resolve();
                                        }, 1000)
                                    }),
                                onRowDelete: oldData =>
                                    new Promise((resolve, reject) => {
                                        setTimeout(() => {
                                            const dataDelete = [...data];
                                            const index = oldData.tableData.id;
                                            dataDelete.splice(index, 1);
                                            setData([...dataDelete]);

                                            resolve();
                                        }, 1000)
                                    }),
                            }}
                        />*/}

                    </Col>
                </Row>
               
            </Form >

        </React.Fragment>
    );
}